import React, { FC, useContext, useMemo, useState } from "react";
import {
  CustomPropertyKeys,
  TranslationKeys,
} from "../../infrastructure/const";
import TranslationsContext from "../../infrastructure/context/translations/translations-context";
import TranslationManager from "../../infrastructure/translation-manager";
import Input from "../common/input";
import IUserContext from "../../infrastructure/context/user/user.context.interface";
import UserContext from "../../infrastructure/context/user/user.context";

type Props = {
  displayValidationMessages: boolean;
  onUpdate: (propertyValue: string) => void;
};

const CprInput: FC<Props> = ({
  displayValidationMessages: formSubmitClicked,
  onUpdate,
}): JSX.Element => {
  const userContext = useContext<IUserContext>(UserContext);
  const { customProperties } = userContext.cart;

  const translationsContext = useContext(TranslationsContext);
  const translationManager = new TranslationManager(translationsContext);

  const [value, setValue] = useState(
    customProperties[CustomPropertyKeys.DK.CPR]
  );
  const [isValid, setIsValid] = useState(!!value);

  const showErrorMessage = useMemo(
    () => !isValid && formSubmitClicked,
    [formSubmitClicked, isValid]
  );

  return (
    <div style={{ marginTop: "2rem" }}>
      <li className="input-container">
        <Input
          label={translationManager.getTranslation(
            TranslationKeys.DK.CPR_NUMBER_LABEL
          )}
          name="cpr-coupon_code"
          value={value}
          isRequired
          hasError={showErrorMessage}
          showValidationText={showErrorMessage}
          onValueChange={(name: string, value: string, valid: boolean) => {
            setIsValid(valid);
            setValue(value);
            onUpdate(value);
          }}
        />
      </li>
    </div>
  );
};

export default CprInput;
